import * as React from 'react';
import dynamic from 'next/dynamic';

import { ModuleUcPrivacyPolicy } from '@packages/common';

const AllServicesListByCategory = dynamic(
  () => import('@moebel.de/usercentrics-client').then((mod) => mod.AllServicesListByCategory),
  {
    ssr: false,
  },
);

export const UcPrivacyPolicy: React.FC<ModuleUcPrivacyPolicy> = () => {
  return (
    <div style={{ padding: '0 24px' }}>
      <AllServicesListByCategory />
    </div>
  );
};
